<template>
  <v-card>
    <!--
    <v-card-title>
      {{title}}
      <v-spacer></v-spacer>
      <v-text-field v-model="search" v-if="needSearch" :append-icon="appendIcon" :label="label" :color="color" single-line hide-details></v-text-field>
    </v-card-title>
    -->
    <v-data-table v-model="selected" :search="search" :style="tableStyle" :custom-filter="filterOnlyCapsText"
      :headers="headers" :items="indexedItems" :show-select="showSelect" :single-select="singleSelect"
      :item-key="rowKey" :fixed-header="true" :height="height" :loading="loading" loading-text="Loading... Please wait"
      :class="tableClass" multi-sort disable-pagination :hide-default-footer="true">
      <!-- フィルタ -->
      <template v-slot:top>
        <v-row>
          <v-col v-if="needSearch" cols="3">
            <v-row class="pa-6">
              <ryou-input v-if="needSearch" v-model="search" :value="search" :label="label" :appendIcon="appendIcon"
                :color="color"></ryou-input>
            </v-row>
          </v-col>
          <v-col cols="9" v-if="needSearch">
            <slot name="filterContainer"></slot>
          </v-col>
          <v-col cols="12" v-if="!needSearch">
            <slot name="filterContainer"></slot>
          </v-col>
        </v-row>
      </template>

      <!-- ヘッダー列アイテム -->
      <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
        <!-- ファイルダウンロード -->
        <div :key="header.id" v-if="header.type==='file'">
          <span v-if="!item[header.value]" style="font-size: 12px;font-style: italic;"></span>
          <a href="#" v-else @click.prevent="doUploadFile(item[header.value], item)">{{item[header.value]}}</a>
        </div>
        <!-- 画像プレビュー -->
        <div :key="header.id" v-else-if="header.type==='img'">
          <span v-if="!item[header.value]" style="font-size: 12px;font-style: italic;"></span>
          <img v-else :src="doGetImgView(item[header.value])" preview="0" height="25px" alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;" />
        </div>
        <!-- 日付 -->
        <div :key="header.id" v-else-if="header.type==='date'">
          {{item[header.value] | dateString}}
        </div>
        <div :key="header.id" v-else-if="header.type==='number'">
          {{item[header.value] | numberString}}
        </div>
        <!-- アイコン -->
        <div :key="header.id" v-else-if="header.type==='icon'">
          <span>
            <v-icon medium color="red" v-if="item[header.value] === 'red'" @click="doHandleIcon(item)">
              mdi-check-circle
            </v-icon>
            <v-icon medium color="green" v-if="item[header.value] === 'green'">
              mdi-check-circle
            </v-icon>
          </span>
        </div>
        <div :key="header.id" v-else-if="header.type==='hidden'">
          <span style="display:none;">
            {{item[header.value]}}
          </span>
        </div>
        <!-- ボタン -->
        <div :key="header.id" v-else-if="header.type==='btn'">
          <v-btn medium color="grey darken-4" class="ma-2 white--text" v-if="item[header.value]==='1'"
            @click="doHandleBtn(item)">
            部屋紐づけ
          </v-btn>
          <v-btn medium color="grey darken-4" class="ma-2 white--text" v-if="item[header.value]==='2'"
            @click="doHandleBtn(item)">
            無効
          </v-btn>
          <v-btn medium color="grey darken-4" class="ma-2 white--text" v-if="item[header.value]==='3'"
            @click="doHandleBtn(item)">
            有効
          </v-btn>
        </div>
        <div :key="header.id" v-else-if="header.type==='link'">
          <a href="url" @click.prevent="doLinkEdit(item)">{{item[header.value]}}</a>
        </div>
        <!-- 編集可能のテキスト -->
        <div :key="header.id" v-else-if="header.type==='text' && dummy">
          <v-text-field v-model="item[header.value]" :rules="inputRules" dense>
          </v-text-field>
        </div>
        <!-- デフォルトの表示 -->
        <div :key="header.id" v-else>
          <div v-if="header.conditionArray">
            <template v-if="header.conditionArray.indexOf(item[header.value]) >= 0">
              <template v-for="(condition,index) in header.conditionArray">
                <div class ="v-data-table" v-if="condition === item[header.value]" :style="header.styleArray[index]" :key="index">
                  {{item[header.value]}}
                </div>
              </template>
            </template>
            <div v-else>
              {{item[header.value]}}
            </div>
          </div>
          <div v-else>
            {{item[header.value]}}
          </div>
        </div>
      </template>

      <!-- 操作ボタン -->
      <template v-slot:item.actions="{ item }">
        <span v-if="handleEdit || handleDelete || handleAdd">
          <v-icon medium class="mr-2" v-if="handleEdit" @click="doHandleEdit(item)">
            mdi-pencil
          </v-icon>
          <v-icon medium class="mr-2" v-if="handleDelete" color="#D84315" @click="doHandleDelete(item)">
            mdi-delete
          </v-icon>
          <v-icon medium class="mr-2" v-if="handleAdd" color="#3949AB" @click="doHandleAdd(item)">
            mdi-plus-thick
          </v-icon>
        </span>
      </template>

    </v-data-table>

    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-card>

</template>

<script>
  import { getRequest } from "@/utils/api";
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

  function clearValue(obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key]) {
        if (typeof obj[key] == "object") {
          clearValue(obj[key]);
        } else {
          obj[key] = "";
        }
      }
    });
  }

  function replaceAll(text, checker, replacer) {
    let lastText = text;
    text = text.replace(checker, replacer);
    if (lastText !== text) {
      return replaceAll(text, checker, replacer);
    }
    return text;
  }

  export default {
    name: "RyouTable",
    components: {
      RyouInput,
      RyouConfirm
    },
    props: {
      handleEdit: {
        type: Function,
        required: false
      },
      handleAdd: {
        type: Function,
        required: false
      },
      handleDelete: {
        type: Function,
        required: false
      },
      uploadFile: {
        type: Function,
        required: false
      },
      queryParams: {
        type: Object,
        required: false,
        default: () => { }
      },
      url: {
        type: Object,
        required: true,
        default: () => { }
      },
      caption: {
        type: String,
        required: false,
        default: ""
      },
      tableClass: {
        type: Array,
        required: false,
        default() {
          return [];
        }
      },
      inputRules: {
        type: Array,
        required: false,
        default() {
          return [];
        }
      },
      businessKey: {
        type: String,
        required: false,
        default: ""
      },
      businessKeys: {
        type: Array,
        required: false,
        default() {
          return [];
        }
      },
      editItems: {
        type: Array,
        required: false,
        default() {
          return [];
        }
      },
      multiSort: {
        type: Boolean,
        required: false,
        default: true
      },
      showSelect: {
        type: Boolean,
        required: false,
        default: false
      },
      singleSelect: {
        type: Boolean,
        required: false,
        default: false
      },
      dummy: {
        type: Boolean,
        required: false,
        default: false
      },
      needSearch: {
        type: Boolean,
        required: false,
        default: false
      },
      title: {
        type: String,
        required: false,
        default: " "
      },
      label: {
        type: String,
        required: false,
        default: "検索 "
      },
      appendIcon: {
        type: String,
        required: false,
        default: "mdi-magnify "
      },
      color: {
        type: String,
        required: false,
        default: ""
      },
      headers: {
        type: Array,
        required: true,
        default: () => []
      },
      pageSize: {
        type: Number,
        required: false,
        default: 10
      },
      sortBy: {
        type: Array,
        required: false,
        default: () => []
      },
      sortDesc: {
        type: Array,
        required: false,
        default: () => []
      },
      rowKey: {
        type: String,
        required: false,
        default() {
          "id";
        }
      },
      height: {
        type: Number,
        required: false,
        default: 300
      },
      tableStyle: {
        type: String,
        required: false,
        default: "word-break: break-all !important"
      },
      autoLoad: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    data() {
      return {
        search: "",
        loading: false,
        totalItems: 0,
        options: {},
        selected: [],
        dataSource: [],
        indexes: [],
        tableChangeOption: {
          current: 1,
          pageSize: 10,
          sortBy: "",
          sortDesc: ""
        }
      };
    },
    created() {
      if (this.autoLoad) {
        this.loadData();
      }
    },
    methods: {
      loadData(arg) {
        if (this.dummy) {
          this.dataSource = this.editItems;
          return;
        }

        if (!this.url.list) {
          this.$toast.open({
            message: "url.list属性を設定してください",
            type: "error"
          });
          return;
        }
        var token = this.$store.getters.getUserToken
        var params = this.queryParams;
        console.log(arg);
        // if (arg == 1) {
        //   params.pageNo = 1;
        // } else {
        //   params.pageNo = this.tableChangeOption.current;
        // }
        // params.pageSize = this.tableChangeOption.pageSize;
        // params.column = this.tableChangeOption.sortBy;
        // params.order = this.tableChangeOption.sortDesc;
        this.loading = true;

        var that = this;
        getRequest(this.url.list, params, token).then(data => {
          if (data.success) {
              let dataSource = data.result;
            // let search = that.search.trim().toLowerCase();

            // if (that.needSearch && search) {
            //   dataSource = dataSource.filter(item => {
            //     return Object.values(item)
            //       .join(",")
            //       .toLowerCase()
            //       .includes(search);
            //   });
            // }

            if (dataSource) {
              that.dataSource = dataSource;
              that.totalItems = data.length;
            }

            setTimeout(() => {
              that.loading = false;
            }, 100);
          }
        });
      },
      getCheckedRows() {
        var checkedRowArray = [];
        if (this.indexes.length > 0) {
          this.indexes.forEach(idx => {
            var checkedRow = { ...this.indexedItems[idx - 1] };
            checkedRowArray.push(checkedRow);
          });
        }
        return checkedRowArray;
      },
      getLastRow() {
        var length = this.indexedItems.length;
        var lastRow = { ...this.indexedItems[length - 1] };
        clearValue(lastRow);
        return lastRow;
      },
      addRow(newRow) {
        var length = this.indexedItems.length;
        delete newRow.rowIndex;
        this.dataSource = [...this.indexedItems];
        this.dataSource.splice(length, 0, newRow);
      },
      addRows(newRowArray) {
        newRowArray.forEach(newRow => {
          this.addRow(newRow);
        });
      },
      getAllRow() {
        return this.indexedItems;
      },
      doGridAddRow() {
        var newRow = {};
        var length = this.indexedItems.length;

        if (this.indexes.length > 0) {
          var lastIndex = this.indexes[this.indexes.length - 1];
          newRow = { ...this.indexedItems[lastIndex - 1] };
        } else {
          newRow = { ...this.indexedItems[length - 1] };
          clearValue(newRow);
        }

        delete newRow.rowIndex;
        this.dataSource.splice(length, 0, newRow);
      },
      setOrder(boolArray) {
        if (boolArray && boolArray.length > 0) {
          var boolStr = boolArray.join(",");
          return replaceAll(replaceAll(boolStr, "false", "desc"), "true", "asc");
        }
        return "";
      },
      setColumn(columnArray) {
        if (columnArray && columnArray.length > 0) {
          if (columnArray.length === 1) {
            return columnArray[0];
          } else {
            return columnArray.join(",");
          }
        }
        return "";
      },

        doHandleEdit(item)
        {
            this.handleEdit(item);
      },

      doHandleDelete(item) {
        if (this.$listeners["selfDelHandler"]) {
          this.$emit("selfDelHandler", item);
          return;
        }
        var ids = "";
        if (this.businessKey) {
          ids = item[this.businessKey];
        } else {
          this.businessKeys.forEach(key => {
            ids += item[key] + "/";
          });
        }
        var that = this;
        this.$refs.confirm
          .open("削除", "削除します。宜しいですか？", { color: "blue" })
          .then(confirm => {
            if (confirm) {
              if (!that.dummy) {
                that.handleDelete(ids);
              } else {
                var idx = item.rowIndex;
                that.dataSource = [...that.indexedItems];
                that.dataSource.splice(idx - 1, 1);
              }
            }
          });
      },

      doHandleAdd(item) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$emit("doHandleGridAdd", item);
        }, 100);
      },

      doUploadFile(text, item) {
        this.uploadFile(text, item);
      },

      doGetImgView(text) {
        return this.getImgView(text);
      },

      doHandleIcon(item) {
        //console.log(item);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$emit("doHandleIcon", item);
        }, 100);
      },
      doLinkEdit(item) {
        //console.log(item);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$emit("doLinkEdit", item);
        }, 100);
      },
      doHandleBtn(item) {
        console.log(item);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$emit("doHandleBtn", item);
        }, 100);
      },
      filterOnlyCapsText(value, search) {
        return (
          value != null &&
          search != null &&
          typeof value === "string" &&
          value
            .toString()
            .toLowerCase()
            .indexOf(search.toString().toLowerCase()) !== -1
        );
      },
      clearTable() {
        this.dataSource = [];
      }
    },
    computed: {
      // params() {
      //   return {
      //     query: this.search
      //   };
      // },
      indexedItems() {
        // return this.dataSource.map((item, index) => ({
        //   rowIndex: index + 1,
        //   ...item
        // }));
        var tmpArray = [];
        this.dataSource.forEach((item, index) => {
          item.rowIndex = index + 1;
          tmpArray.push(item);
        });
        return tmpArray;
      }
    },
    watch: {
      // options: {
      //   handler() {
      //     console.log("****************options handler***************");
      //     const {
      //       sortBy,
      //       sortDesc,
      //       page,
      //       itemsPerPage,
      //       groupBy,
      //       groupDesc
      //     } = this.options;
      //     var sortByArray = [];
      //     var sortDescArray = [];
      //     Object.assign(sortByArray, sortBy);
      //     Object.assign(sortDescArray, sortDesc);
      //     if (groupBy && groupBy.length > 0) {
      //       sortByArray.splice(0, 0, groupBy[0]);
      //       sortDescArray.splice(0, 0, groupDesc[0]);
      //     }
      //     this.tableChangeOption.sortBy = this.setColumn(sortByArray);
      //     this.tableChangeOption.sortDesc = this.setOrder(sortDescArray);
      //     this.tableChangeOption.current = page;
      //     this.tableChangeOption.pageSize = itemsPerPage;
      //     this.loadData();
      //   },
      //   deep: true
      // },
      // params: {
      //   handler() {
      //     // console.log("****************params handler for search***************");
      //     // const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      //     // this.tableChangeOption.sortBy = this.setColumn(sortBy);
      //     // this.tableChangeOption.sortDesc = this.setOrder(sortDesc);
      //     // this.tableChangeOption.current = page;
      //     // this.tableChangeOption.pageSize = itemsPerPage;
      //     this.loadData();
      //   },
      //   deep: true
      // },
      selected(items) {
        var keys = [];
        this.indexes = [];
        items.forEach(item => {
          // keys.push(item[this.businessKey]);
          var ids = "";
          if (this.businessKey) {
            ids = item[this.businessKey];
          } else {
            this.businessKeys.forEach(key => {
              ids += item[key] + "/";
            });
          }
          keys.push(ids);

          this.indexes.push(item.rowIndex);
        });
        this.$emit("getSelectedRowKeys", items, keys);
      }
    }
  };
</script>

<style>
    .v-data-table-header .text-start {
        background-color: #64b5f6 !important;
        font-size: 1.25rem !important;
        font-weight: 500;
        line-height: 2rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
    }
    
  /* .truncate {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
